import { X, Cable, Trash2 } from 'lucide-react';
import useStore from '../lib/store';

export default function ConnectionModal({ connection, onClose }) {
  const devices = useStore(state => state.devices);
  const removeConnection = useStore(state => state.removeConnection);

  const device1 = devices.find(d => d.id === connection.device1);
  const device2 = devices.find(d => d.id === connection.device2);

  if (!device1 || !device2) return null;

  const handleDelete = () => {
    if (confirm('Delete this connection?')) {
      removeConnection(connection.id);
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content connection-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">
            <Cable size={24} />
            Connection Details
          </h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="connection-details">
          <div className="connection-endpoint">
            <div className="endpoint-label">From</div>
            <div className="endpoint-device">{device1.name}</div>
            <div className="endpoint-info">{device1.ip}</div>
            <div className="endpoint-port">Port {connection.port1 + 1}</div>
          </div>

          <div className="connection-cable">
            <Cable size={32} className="cable-icon" />
            <div className="cable-type">Ethernet Cable</div>
          </div>

          <div className="connection-endpoint">
            <div className="endpoint-label">To</div>
            <div className="endpoint-device">{device2.name}</div>
            <div className="endpoint-info">{device2.ip}</div>
            <div className="endpoint-port">Port {connection.port2 + 1}</div>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-delete-connection" onClick={handleDelete}>
            <Trash2 size={18} />
            Delete Connection
          </button>
        </div>
      </div>
    </div>
  );
}
